<div>
  <select [formControl]="control">
    <option *ngFor="let option of options" [value]="option.poId">
      {{option.poName}}
    </option>
  </select>
</div>